import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import React, { useEffect, useMemo, useState } from "react";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "./NotifyShortage.css";
import axios from "./../../axios";
import { toast } from "react-toastify";
import TableComponent from "./TableComponent/TableComponent";
import * as XLSX from "xlsx";
import SendEmailDialog from "./SendEmailDialog";
import DatePicker from "react-datepicker";
import { ArrowDownWideNarrow, Loader2, Search } from "lucide-react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { format } from "date-fns";

function NotifyShortage() {
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicYearSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  // const [selectedAcademicSessionId, setSelectedAcademicSessionId] = useState(null);
  // const [selectedTimetableId, setSelectedTimetableId] = useState(null);
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [students, setStudents] = useState([]);
  const [isModified, setIsModified] = useState(false);
  const [enableSubmitBtn, setEnableSubmitBtn] = useState(false);
  const [academicSessionData, setAcademicSessionData] = useState([]);
  const [schoolSessionTimeTable, setSchoolSessionTimeTable] = useState([]);
  const [criteria, setCriteria] = useState("");
  const [permanent, setPermanent] = useState(null);
  const [academicYearId, setAcademicYearId] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [emailDialog, setEmailDialog] = useState(false);
  const [totalStudentCounts, settotalStudentCounts] = useState(false);
  const [DisplayUIdDateStart, setDisplayUIdDateStart] = useState("");
  const [DisplayUIdDateEnd, setDisplayUIdDateEnd] = useState("");
  const [isGettingData, setIsGettingData] = useState(false);
  const [searchItem, setSearchItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [schoolName, setSchoolName] = useState(null);
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
  });
  const { standards, sections } = dropdownLists;
  const standardList = [];
  const sectionList = [];

  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );
  const general_role = JSON.parse(localStorage.getItem("general_role"));

  const userInfo = JSON.parse(localStorage.getItem("UserInformation"));

  useEffect(() => {
    if (userInfo) {
      setSchoolName(userInfo?.school.name);
    }
  }, []);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // useEffect(() => {
  //   if (CTRole_Information && CTRole_Information.length > 0) {
  //     CTRole_Information?.forEach((obj) => {
  //       if (obj.is_class_teacher === true) {
  //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //           standardList.push(obj.standard_id);
  //         }
  //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //           sectionList.push(obj.section_id);
  //         }
  //       }
  //     });
  //   }

  //   if (CoRole_Information && CoRole_Information.length > 0) {
  //     CoRole_Information?.forEach((obj) => {
  //       if (obj?.is_class_co_ordinator === true) {
  //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //           standardList.push(obj.standard_id);
  //         }
  //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //           sectionList.push(obj.section_id);
  //         }
  //       }
  //     });
  //   }
  //   // if (general_role && general_role.length > 0) {
  //   //     general_role?.forEach((obj) => {
  //   //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //   //             standardList.push(obj.standard_id);
  //   //         }
  //   //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //   //             sectionList.push(obj.section_id);
  //   //         }
  //   //     });
  //   // }
  //   standardList.length > 0 &&
  //     setDropdownLists((prev) => ({ ...prev, standards: standardList }));

  //   sectionList.length > 0 &&
  //     setDropdownLists((prev) => ({ ...prev, sections: sectionList }));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    CoRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
  };

  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CoRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  // useEffect(() => {
  //     const handleAcademicYear = async () => {
  //         try {
  //             const getRes = await axios.get(`/api/v1/school/academicYear/get/school/${schoolId}`)
  //             if (getRes) {
  //                 setAcademicYearId(getRes?.data?.data?.id);
  //             }
  //         } catch (error) {
  //             toast.error(error.response.data.message)
  //         }

  //     };
  //     handleAcademicYear()
  //     handleAcademicYearData()
  //     handleSchoolTimeTableData()
  // }, [schoolId, academicYearId])

  // const handleAcademicYearChange = (value) => {
  //     setSelectedAcademicSessionId(value)
  //     setSelectedTimetableId(null);
  //     setIsModified(false);
  //     setShowTable(false);
  // }
  // const handleTimetableChange = (value) => {
  //     setSelectedTimetableId(value);
  //     setIsModified(false);
  //     setShowTable(false);
  // };

  const handleClassChange = (value) => {
    setClassId(value);
    setIsModified(false);
    setShowTable(false);
    setSectionId(null);
  };
  const handleSectionChange = (value) => {
    setSectionId(value);
    setIsModified(false);
    setShowTable(false);
  };

  useEffect(() => {
    if (new Date(selectedEndDate) <= new Date(selectedStartDate)) {
      toast.error("End date must be greater than the start date.");
    }
  }, [selectedStartDate, selectedEndDate, permanent]);

  useEffect(() => {
    if (
      !classId ||
      !sectionId ||
      !selectedStartDate ||
      !selectedEndDate ||
      !permanent
    ) {
      setEnableSubmitBtn(true);
    } else {
      setEnableSubmitBtn(false);
    }
  }, [classId, sectionId, selectedStartDate, selectedEndDate, permanent]);

  const dateHelper = (a) => {
    const inputDate = new Date(a);
    const month = inputDate.getMonth() + 1;
    const day = inputDate.getDate();
    const year = inputDate.getFullYear();
    const formattedDate = `${year}/${month}/${day}`;
    return formattedDate;
  };

  const dateHelperDisplayOnUI = (a) => {
    const inputDate = new Date(a);
    const month = String(inputDate.getMonth() + 1).padStart(2, "0");
    const day = String(inputDate.getDate()).padStart(2, "0");
    const year = inputDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getDataofTable = async () => {
    let body = {
      academicSessionId: academicYearSessionId,
      standardId: classId,
      sectionId: sectionId,
      timetableSessionId: timeTableSessionId,
      startDate: formatDate(selectedStartDate),
      endDate: formatDate(selectedEndDate),
      criteria: permanent,
    };
    try {
      const response = await axios.post(`/api/v1/attendanceShortage`, body);
      setStudents(response.data?.data?.filteredStudents);
      settotalStudentCounts(response?.data?.data?.totalStudentCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filteredAndSortedStudents = useMemo(() => {
    let list = students || [];
    // Filter
    list = list.filter((student) =>
      student?.student?.name?.toLowerCase().includes(searchItem?.toLowerCase()),
    );

    // Sort
    list = list.sort((a, b) => {
      const nameA = a?.student?.name?.toLowerCase();
      const nameB = b?.student?.name?.toLowerCase();
      return sortOrder === "asc"
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    });

    return list;
  }, [students, searchItem, sortOrder]);

  const paginatedStudents = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return filteredAndSortedStudents.slice(start, start + rowsPerPage);
  }, [filteredAndSortedStudents, currentPage, rowsPerPage]);

  const totalPages = Math.ceil(filteredAndSortedStudents.length / rowsPerPage);

  const handleTableUi = () => {
    setShowTable(true);
    getDataofTable();
  };

  const handleDownloadExcel = () => {
    if (!students || students.length === 0) {
      toast.error("No data available to download");
      return;
    }

    const selectedStudentDetails = students
      .filter((student) => selectedStudents.includes(student.student._id))
      .map((student, index) => ({
        "Sr. No": index + 1,
        "Roll Code": student.student.code,
        "Admission No": student.student.addmissionNo,
        "Student Name": student.student.name,
        Email: student.student.email,
        "Attendance %": student.attendancePercentage,
        "Present Days": student.presentDays,
        "Total Days": student.totalDays,
      }));

    const worksheet = XLSX.utils.json_to_sheet(
      selectedStudents.length > 0
        ? selectedStudentDetails
        : students.map((student, index) => ({
            "Sr. No": index + 1,
            "Roll Code": student.student.code,
            "Admission No": student.student.addmissionNo,
            "Student Name": student.student.name,
            Email: student.student.email,
            "Attendance %": student.attendancePercentage,
            "Present Days": student.presentDays,
            "Total Days": student.totalDays,
          })),
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
    XLSX.writeFile(workbook, "ShortageStudents.xlsx");
    setSelectedStudents([]);
  };

  // const handleSendEmail = async (emailBody) => {
  //     const selectedStudentDetails = students?.filter((student) =>
  //         selectedStudents.includes(student?.student?._id)
  //     ).map((student) => student?.student?.email);
  //     const payload = {
  //         shortageStudent: selectedStudentDetails,
  //         emailBody: emailBody,
  //     };
  //     try {
  //         setIsGettingData(true);
  //         const res = await axios.post(`/api/v1/shortageMail`, payload)
  //         if (res) {
  //             toast.success(res?.data?.message);
  //             setSelectedStudents([]);
  //             setIsGettingData(false);
  //         }
  //     } catch (error) {
  //         console.error('Error sending email:', error);
  //         toast.error('Error sending email');
  //     }
  // };

  const generateDefaultEmailBody = () => {
    return `Dear Student,

    This is to inform you that your attendance shortage between ${format(new Date(selectedStartDate), "dd MMM yyyy")} and ${format(new Date(selectedEndDate), "dd MMM yyyy")}.
    The required attendance percentage criteria is ${permanent}%.
    Please contact the class teacher for further clarification.

    Regards,
    ${schoolName}`;
  };

  const handleSendEmail = async (emailBody = generateDefaultEmailBody()) => {
    const selectedStudentDetails = students
      ?.filter((student) => selectedStudents.includes(student?.student?._id))
      .map((student) => ({
        studentId: student?.student?._id,
        attendance: student?.attendancePercentage,
        requiredAttendance: Number(permanent),
        email: student?.student?.email,
        startDate: selectedStartDate
          ? format(new Date(selectedStartDate), "dd MMM yyyy")
          : "",
        endDate: selectedEndDate
          ? format(new Date(selectedEndDate), "dd MMM yyyy")
          : "",
      }));

    const payload = {
      shortageStudent: selectedStudentDetails,
      emailSubject: "Attendance Shortage Notification",
      emailBody: emailBody,
    };

    setIsGettingData(true);
    try {
      const res = await axios.post(`/api/v1/shortageMail`, payload);
      // || isGettingData ? "#fab973" : "#F77F00"

      if (res) {
        toast.success(res?.data?.message);
        setSelectedStudents([]);
      }
      toast.success(res?.message);
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("Error sending email");
    } finally {
      setIsGettingData(false);
    }
  };

  return (
    <div className="attendance-container">
      <div className="card">
        <h2 className="card-header">Notify Shortage</h2>
        <div className="row">
          <div
            className="d-flex flex-wrap align-items-center gap-3"
            style={{ width: "100%" }}
          >
            {/* Class */}
            <FormControl size="small" style={{ width: 180 }}>
              <InputLabel>Class*</InputLabel>
              <Select
                label="Class*"
                value={classId || ""}
                onChange={(e) => handleClassChange(e.target.value)}
              >
                <MenuItem value="null">Select Class</MenuItem>
                {standardArr?.length > 0 &&
                  [...standardArr]
                    .sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);

                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) {
                        return aNum - bNum; // numeric sort
                      }

                      return a.name.localeCompare(b.name); // alphabetical sort
                    })
                    .map((standard, index) => (
                      <MenuItem
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>

            {/* Section */}
            <FormControl size="small" style={{ width: 180 }}>
              <InputLabel>Section*</InputLabel>
              <Select
                label="Section*"
                value={sectionId || ""}
                onChange={(e) => handleSectionChange(e.target.value)}
              >
                <MenuItem value="null">Select Section</MenuItem>
                {sectionArr
                  ?.slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((section) => (
                    <MenuItem key={section.id} value={section.id}>
                      {section.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <div>
              <DatePicker
                selected={selectedStartDate}
                onChange={(date) => {
                  setSelectedStartDate(date);
                  setShowTable(false);
                }}
                dateFormat="dd/MM/yyyy"
                placeholderText="Choose Start date"
                className="form-control"
                popperProps={{
                  modifiers: [
                    {
                      name: "zIndex",
                      enabled: true,
                      phase: "beforeWrite",
                      fn({ state }) {
                        state.styles.popper.zIndex = 9999999;
                      },
                    },
                  ],
                }}
              />
            </div>

            {/* End Date */}

            <div>
              <DatePicker
                selected={selectedEndDate}
                onChange={(date) => {
                  setSelectedEndDate(date);
                  setShowTable(false);
                }}
                dateFormat="dd/MM/yyyy"
                placeholderText="Choose End date"
                className="form-control"
                popperProps={{
                  modifiers: [
                    {
                      name: "zIndex",
                      enabled: true,
                      phase: "beforeWrite",
                      fn({ state }) {
                        state.styles.popper.zIndex = 9999999;
                      },
                    },
                  ],
                }}
              />
            </div>

            {!permanent ? (
              <TextField
                size="small"
                type="number"
                label="Shortage Criteria*"
                value={criteria || ""}
                onChange={(e) => {
                  setCriteria(e.target.value);
                  setShowTable(false);
                }}
                style={{ width: 140 }}
              />
            ) : (
              <div className="criteria-display d-flex align-items-center gap-2">
                <span className="badge">{permanent}%</span>
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  className="edit-icon"
                  onClick={() => {
                    setPermanent(null);
                    setShowTable(false);
                  }}
                />
              </div>
            )}

            {!permanent && (
              <button
                className="btn btn-success "
                disabled={
                  !criteria || Number(criteria) < 0 || Number(criteria) > 100
                }
                onClick={() => setPermanent(criteria)}
              >
                <FontAwesomeIcon icon={faCheck} />
              </button>
            )}

            {/* Apply Button */}
            <Button
              variant="contained"
              style={{ width: 100, backgroundColor: "orange", color: "white" }}
              disabled={
                !classId ||
                !sectionId ||
                !selectedStartDate ||
                !selectedEndDate ||
                !criteria
              }
              onClick={handleTableUi}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>

      {showTable && (
        <>
          <div className="d-flex align-items-center justify-content-between">
            <div className="input-group m-3" style={{ width: "300px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search by name"
                value={searchItem}
                onChange={(e) => setSearchItem(e.target.value)}
              />
              <span className="input-group-text">
                <Search size={16} />
              </span>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div>
                {/* Sort Button */}
                <button
                  className="d-flex align-items-center gap-2"
                  style={{
                    height: "39px",
                    width: "145px",
                    fontWeight: 500,
                    fontSize: "14px",
                    background: "#F77F00",
                    borderRadius: "8px",
                    color: "white",
                    border: "none",
                    padding: "10px",
                  }}
                  onClick={() =>
                    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                  }
                >
                  <ArrowDownWideNarrow size={16} />
                  Sort by {sortOrder === "asc" ? "A - Z" : "Z - A"}
                </button>
              </div>

              <div className="d-flex align-items-center border rounded-2 p-1 gap-1 ">
                <label className="me-2">Rows Per Page</label>
                <select
                  className="form-select"
                  style={{ width: "80px" }}
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  {[5, 10, 20, 50].map((val) => (
                    <option key={val} value={val}>
                      {val}
                    </option>
                  ))}
                </select>
                <small>Entries</small>
              </div>
            </div>
          </div>
          <TableComponent
            students={paginatedStudents}
            setSelectedStudents={setSelectedStudents}
            selectedStudents={selectedStudents}
            placeholder="Search students..."
          />
          <div
            className="position-sticky bottom-0 bg-white p-2 border-top"
            style={{ zIndex: 10 }}
          >
            <div className="d-flex justify-content-end gap-2 align-items-center">
              <div className="actions-container">
                <div className="actions-wrapper">
                  <button
                    className="action-button"
                    style={{
                      background:
                        !selectedStudents?.length || isGettingData
                          ? "#fab973"
                          : "#F77F00",
                    }}
                    disabled={!selectedStudents?.length}
                    onClick={handleDownloadExcel}
                  >
                    Download
                  </button>
                  <button
                    className="action-button"
                    style={{
                      background:
                        !selectedStudents?.length || isGettingData
                          ? "#fab973"
                          : "#F77F00",
                    }}
                    disabled={!selectedStudents?.length}
                    onClick={() => handleSendEmail()}
                  >
                    {isGettingData ? (
                      <>
                        Please Wait...
                      </>
                    ) : (
                      "Notify Shortage"
                    )}
                  </button>
                </div>
              </div>

              <div className="d-flex justify-content-end align-items-center">
                <button
                  className="btn btn-sm btn-outline-secondary me-2"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Prev
                </button>
                <span className="me-3">
                  Page {currentPage} of {totalPages}
                </span>

                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {emailDialog && (
        <SendEmailDialog
          isOpen={emailDialog}
          onClose={() => setEmailDialog(false)}
          onSend={handleSendEmail}
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          criteria={permanent}
          schoolName={schoolName}
          type="shortage"
        />
      )}
    </div>
  );
}

export default NotifyShortage;
